<template>
	<div class="display-flex flex-wrap">
		<div class="flex-col-12">
			<div class="top-section">
				<h2 class="reg">Which app do you want to add {{ itemNameIndefinite }} to?</h2>
				<h3 class="reg">Choose an app to see available {{ availableItems }}</h3>
			</div>
			<div class="action-section pt-5 display-flex flex-wrap">
				<div class="flex-col-9">
					<v-text-field ref="search_field_ref" v-model="searchField" outlined placeholder="Search" hide-details />
				</div>
			</div>
			<!-- uncomment this when we want to enable openDetails button -->
			<!-- <ListSelector
                class="pt-4"
                :items="apps"
                :selectedItemId="selectedAppId"
                @selectItem="(...args) => $emit('selectApp', ...args)"
                allow-keyboard-navigation
                :show-end-hover-area-key="'id'"
                @end-hover-section-clicked="openDetails"
            > -->
			<ListSelector
				v-if="allApps?.length > 0"
				class="pt-4"
				:items="apps"
				:selectedItemId="selectedAppId"
				@selectItem="(...args) => $emit('selectApp', ...args)"
				allow-keyboard-navigation
			>
				<template #item-content="{ item }">
					<AppRow :app="item" />
				</template>
				<template #end-hover="{ item }">
					<DetailsButton @click.stop="openDetails(item.id)" />
				</template>
			</ListSelector>
			<div class="display-flex flex-column width-100 flex-centerize" v-else>
				error while loading data
				<AnemicButton @click="onReload" :loading="isLoading" class="px-3 reload-button">Reload data</AnemicButton>
			</div>
		</div>
		<div class="bottom-section flex-1 display-flex">
			<h3 @click="openAskForIntegrationDialog" class="reg opacity-0-5">
				Can't find what you're looking for? <a role="button" href="#">Request support for an app</a>
			</h3>
		</div>
	</div>
</template>
<script>
import ListSelector from '@/components/common/ListSelector/ListSelector.vue';
import AppRow from './AppRow.vue';
import DetailsButton from './DetailsButton.vue';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getAllActiveServicesList, getService } from '@/store/modules/apps/getters';

import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { indefinite } from '@/utils/language-service';

export default {
	name: 'ChooseApp',
	props: { selectedAppId: { type: Number }, itemName: { type: String }, availableItems: { type: String } },
	components: { ListSelector, AppRow, DetailsButton },
	computed: {
		...mapGettersShorthand({ getAllActiveServicesList, getService }),
		allApps() {
			return this.getAllActiveServicesList;
		},
		apps() {
			return this.allApps.filter(
				(app) =>
					app.has_context &&
					(app.service_name.toLowerCase().includes(this.searchField.toLowerCase()) ||
						app.service_slug.toLowerCase().includes(this.searchField.toLowerCase()))
			);
		},
		itemNameIndefinite() {
			return indefinite(this.itemName);
		},
	},
	methods: {
		...mapActionsShorthand({ mapActionsShorthand }),
		async onReload() {
			this.isLoading = true;
			try {
				await this.getAvailableApps();
			} catch {
				this.$toast.error('Something went wrong, please try again later');
			} finally {
				this.isLoading = false;
			}
		},
		openDetails(appId) {
			console.log('openDetails', appId);
		},
		openAskForIntegrationDialog() {
			AppDialogManagerService.openIntegrationDialog();
		},
	},
	data() {
		return { searchField: '', isLoading: false };
	},
	mounted() {
		this.$nextTick(() => this.$refs['search_field_ref'].focus());
	},
};
</script>
<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/top-section.scss';
.list-selector {
	max-height: 300px;
	overflow-y: auto;
}
.bottom-section {
	align-items: flex-end;
	h3 {
		color: #303133;
		a {
			color: #303133;
			font-weight: 400;
		}
	}
}
.reload-button {
	color: var(--bg-color);
	height: 45px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	background-color: #6762f0 !important;
}
</style>
